// component
import MonitorIcon from '@mui/icons-material/Monitor';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import SettingsIcon from '@mui/icons-material/Settings';
// import VerifiedIcon from '@mui/icons-material/Verified';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import BadgeIcon from '@mui/icons-material/Badge';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HandymanIcon from '@mui/icons-material/Handyman';
import PlaceIcon from '@mui/icons-material/Place';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import SellIcon from '@mui/icons-material/Sell';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import HistoryIcon from '@mui/icons-material/History';
// import ReceiptIcon from '@mui/icons-material/Receipt';

const storedUser = JSON.parse(localStorage.getItem('profile'));
const branchRoles = ['MANAGER', 'BRANCH_MANAGER'];

const isManager = storedUser?.role && branchRoles.includes(storedUser.role);

const navConfig = (isManager && [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: <DashboardIcon />,
  },
  {
    title: 'Assets',
    path: '/dashboard/assets',
    icon: <MonitorIcon />,
  },
  {
    title: 'Transfers',
    path: '/dashboard/transfers',
    icon: <UnfoldMoreIcon />,
  },
  {
    title: 'Maintenance',
    path: '/dashboard/maintenance',
    icon: <HandymanIcon />,
  },
  {
    title: 'Handovers',
    path: '/dashboard/handovers',
    icon: <HandshakeIcon />,
  },
  {
    title: 'Disposals',
    path: '/dashboard/disposals',
    icon: <SellIcon />,
  },
  {
    title: 'Audit Trail',
    path: '/dashboard/audit-trail',
    icon: <HistoryIcon />,
  },
  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: <SettingsIcon />,
  },
]) ||
  (storedUser?.role === 'SERVICE_PROVIDER' && [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      icon: <DashboardIcon />,
    },
    {
      title: 'Maintenance',
      path: '/dashboard/maintenance',
      icon: <HandymanIcon />,
    },
    {
      title: 'Settings',
      path: '/dashboard/settings',
      icon: <SettingsIcon />,
    },
  ]) || [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      icon: <DashboardIcon />,
    },
    {
      title: 'Assets',
      path: '/dashboard/assets',
      icon: <MonitorIcon />,
    },
    {
      title: 'Transfers',
      path: '/dashboard/transfers',
      icon: <UnfoldMoreIcon />,
    },
    // {
    //   title: 'Categories',
    //   path: '/dashboard/categories',
    //   icon: <CategoryIcon />,
    // },
    {
      title: 'Locations',
      path: '/dashboard/locations',
      icon: <PlaceIcon />,
    },
    {
      title: 'Departments',
      path: '/dashboard/departments',
      icon: <CorporateFareIcon />,
    },
    {
      title: 'Maintenance',
      path: '/dashboard/maintenance',
      icon: <HandymanIcon />,
    },
    // {
    //   title: 'Invoices',
    //   path: '/dashboard/invoices',
    //   icon: <ReceiptIcon />,
    // },
    {
      title: 'Audits',
      path: '/dashboard/audits',
      icon: <NoteAltIcon />,
    },
    {
      title: 'Audit Trail',
      path: '/dashboard/audit-trail',
      icon: <HistoryIcon />,
    },
    // {
    //   title: 'Reconcile Audit',
    //   path: '/dashboard/reconcileaudit',
    //   icon: <VerifiedIcon />,
    // },
    // {
    //   title: 'Handovers',
    //   path: '/dashboard/handovers',
    //   icon: <HandshakeIcon />,
    // },
    {
      title: 'Disposals',
      path: '/dashboard/disposals',
      icon: <SellIcon />,
    },
    {
      title: 'Reports',
      path: '/dashboard/reports',
      icon: <AnalyticsIcon />,
    },
    {
      title: 'People',
      path: '/dashboard/people',
      icon: <BadgeIcon />,
    },
    {
      title: 'Settings',
      path: '/dashboard/settings',
      icon: <SettingsIcon />,
    },
  ];

export default navConfig;
